import React, { useState } from 'react'
import { IoIosCopy } from 'react-icons/io'

type Props = {
  size: number,
  string: string
}

const CopyToClipboard: React.FC<Props> = ({ size, string }) => {
  const [visible, setVisible] = useState(false)

  const handleClick = () => {
    navigator.clipboard.writeText(string)
    setVisible(true)

    setTimeout(() => {
      setVisible(false)
    }, 1000)
  }

  return (
    <>
      <IoIosCopy
        className="icon-copy"
        size={size}
        onClick={handleClick}
        title="Copy to clipboard"
        data-testid="CopyToClipboard"
      />

      {visible && <span className="copy-notification">Copied!</span>}
    </>
  )
}

export default CopyToClipboard
